import React, { useEffect, useState } from 'react';
import CardGroup from '../common/CardGroup';
import LoaderButton from '../LoaderButton';
import { API } from 'aws-amplify';
import { Notification } from '../../libs/errorLib';
import { useAppContext } from '../../libs/contextLib';
import './UserForm.css';

export default function UserForm({ user: userProp }) {
  const { session, setSession } = useAppContext();
  const user = userProp;
  const [fields, setFields] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    country: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFields({
      firstname: user.firstname || '',
      lastname: user.lastname || '',
      email: user.email || '',
      phone: user.phone || '',
      country: user.country || '',
    });
  }, [user]);

  function handleChange(e) {
    setFields(f => ({ ...f, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (!user || !user._id) throw new Error('No user');
      const updated = await API.put('vivelo', `/users/${user._id}`, {
        body: fields
      });
      Notification('success', 'Tu información fue actualizada');
      if (setSession) {
        setSession(s => ({ ...s, user: { ...user, ...fields } }));
      }
    } catch (e) {
      Notification('error', 'No fue posible actualizar tu información');
    }
    setIsLoading(false);
  }

  return (
    <div className="user-form-wrapper">
      <h1 className="user-form-title">Mi Perfil</h1>
      <CardGroup className="user-form-card">
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="user-form-row">
            <div className="user-form-field">
              <label>Nombre</label>
              <input name="firstname" value={fields.firstname} onChange={handleChange} className="input-theme" autoComplete="given-name" />
            </div>
            <div className="user-form-field">
              <label>Apellido</label>
              <input name="lastname" value={fields.lastname} onChange={handleChange} className="input-theme" autoComplete="family-name" />
            </div>
          </div>
          <div className="user-form-field">
            <label>Correo electrónico</label>
            <input name="email" value={fields.email} readOnly className="input-theme" autoComplete="email" />
          </div>
          <div className="user-form-field">
            <label>Teléfono</label>
            <input name="phone" value={fields.phone} onChange={handleChange} className="input-theme" autoComplete="tel" />
          </div>
          <div className="user-form-field">
            <label>Dirección</label>
            <input name="country" value={fields.country} onChange={handleChange} className="input-theme" autoComplete="country" />
          </div>
          <div className="user-form-actions">
            <LoaderButton
              type="submit"
              className="btn-theme-primary user-form-save-btn"
              isLoading={isLoading}
              disabled={!fields.firstname || !fields.lastname}
            >
              Guardar cambios
            </LoaderButton>
          </div>
        </form>
      </CardGroup>
    </div>
  );
} 